import { CleanButton, bodyRegularStyle, breakpoints } from '@gassan-ui'
import styled from 'styled-components'

export const FilterButton = styled(CleanButton)`
  ${bodyRegularStyle};
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.colors.shades[800]};
  margin-bottom: 1rem;
  svg {
    margin-left: 0.5rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    display: none;
  }
`
